<template>
<div class="form-part">
  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.irtc_fwname_sel" class="mt-1">Filter</b-form-checkbox>
    </div>
    <div class="col-4">
      <b-form-input v-model="fields.irtc_fwname" class="fits-width"></b-form-input>
    </div>
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.irtc_instruml_sel" class="mt-1">Instrument Left</b-form-checkbox>
    </div>
    <div class="col-4">
      <b-form-input v-model="fields.irtc_instruml" class="fits-width"></b-form-input>
    </div>
  </div>

  <div class="row">
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.irtc_mode_sel" class="mt-1">Mode</b-form-checkbox>
    </div>
    <div class="col-4">
      <b-form-input v-model="fields.irtc_mode" class="fits-width"></b-form-input>
    </div>
    <div class="col-2 label-left">
      <b-form-checkbox v-model="fields.irtc_instrumr_sel" class="mt-1">Instrument Right</b-form-checkbox>
    </div>
    <div class="col-4">
      <b-form-input v-model="fields.irtc_instrumr" class="fits-width"></b-form-input>
    </div>
  </div>
</div>
</template>

<script>
import {
  mapState
} from 'vuex';

export default {
  name: 'Irtc',
  computed: mapState({
    fields: state => state.searchForm.fields,
    fieldErrors: state => state.searchForm.fieldErrors
  })
}
</script>
